import { WineColorEnum } from "@/constants/enums/wineColor.enum";
import { isEuropeanUnionCountry } from "@/constants/countries";
import { DeliveryContentData } from "@/types/forms/bo/expeditionBo.form";

export type DestinationRegion = "UE" | "USA" | "OTHER";

export const getDestinationRegion = (countryCode: string | undefined | null): DestinationRegion => {
  if (countryCode && isEuropeanUnionCountry(countryCode)) {
    return "UE";
  }
  if (countryCode === "US") {
    return "USA";
  }
  return "OTHER";
};

/** Placeholder values for fields that are not collected in UE simplified mode but are still required by the schema. */
const UE_PLACEHOLDER_FIELDS: Pick<
  DeliveryContentData,
  "wineName" | "year" | "alcoholPercent" | "color"
> = {
  wineName: "-",
  year: undefined,
  alcoholPercent: 0,
  color: "ROUGE" as WineColorEnum,
};

const FULL_EMPTY_FIELDS: Pick<
  DeliveryContentData,
  "wineName" | "year" | "alcoholPercent" | "color"
> = {
  wineName: undefined as unknown as string,
  year: undefined,
  alcoholPercent: undefined as unknown as number,
  color: undefined as unknown as WineColorEnum,
};

export const getDefaultDeliveryContentRow = (
  destinationRegion: DestinationRegion,
  overrides: Partial<DeliveryContentData> = {},
  viaImportedInvoice?: boolean | null,
): DeliveryContentData => {
  const isUeWithImportedInvoice = destinationRegion === "UE" && !!viaImportedInvoice;
  const baseFields = isUeWithImportedInvoice ? UE_PLACEHOLDER_FIELDS : FULL_EMPTY_FIELDS;

  return {
    ...baseFields,
    volume: 0.75,
    numberOfBottles: 0,
    unitPrice: 0,
    productId: destinationRegion === "UE" ? "-" : undefined,
    productUSAId: undefined,
    ...overrides,
  };
};
